<template>
  <draggable
    class="c__container"
    :class="{'c__container-active': componentList.length == 0}"
    tag="ul"
    :list="componentList"
    :group="{ name: 'g1', pull: 'clone', put: true }"
    item-key="name"
    :clone="cloneItem"
    @start="onDragStart"
    @end="onDragEnd"
    @change="onDragChange"
    :disabled="readonly"
  >
    <template #item="{ element }">
      <div class="c__item">
        <keep-alive>
          <component 
            :is="getComponent(element.component)" 
            :key="element.id" 
            :block="element" 
            :readonly="readonly"
            :jsoneditor="jsoneditor"
            :selectable="selectable"
          />
        </keep-alive>
      </div>
    </template>
  </draggable>
  <div class="empty-container" v-if="componentList.length == 0">
    <div class="empty-message">
      Добавьте элемент из боковой панели
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { defineAsyncComponent, markRaw } from 'vue';
import { uid as idGenerator } from '@/utils/uid-generate';
import { replaceIdsWithUids } from '@/utils/id-generate';
import { safeClone } from '@/utils/clone.js';

export default {
  name: "nested-draggable",
  props: {
    componentList: { required: true, type: Array },
    readonly: { type: Boolean, default: false },
    jsoneditor: { type: Boolean, default: false },
  },
  data() {
    return {
      componentsMap: {
        header: markRaw(defineAsyncComponent(() => import('@/components/blocks/Heroes/header.vue'))),
        uni: markRaw(defineAsyncComponent(() => import('@/components/blocks/Heroes/uni.vue'))),
      }
    };
  },
  computed: {
    selectable () {
      return this.$store.getters['choosedElement/isChoosing']
    }
  },
  mounted () {
  },
  methods: {
    getComponent(block_id) { return this.componentsMap[block_id]; },

    cloneItem(item) {
      let clone = safeClone(item);
      clone.id = idGenerator();
      clone = replaceIdsWithUids(clone);
      return clone;
    },

    onDragStart(event) {
      if (this.readonly) return;
      this.$emit('drag-start', event);
    },

    onDragEnd(event) {
      if (!this.readonly) this.$store.dispatch('landing/UPDATE_LANDING', this.componentList);
      this.$emit('drag-end', event);
    },

    onDragChange(event) {
      if (event.added?.element) {
        let newElement = safeClone(event.added.element);
        newElement.id = idGenerator();
        newElement = replaceIdsWithUids(newElement);
        this.componentList.splice(event.added.newIndex, 1, newElement);
        this.$store.dispatch('landing/UPDATE_INDEXES', newElement);
      }
      this.$emit('drag-change', event);
    }
  },
  components: { draggable: markRaw(draggable) }
};
</script>


<style scoped>
.c__item-margin-bottom {
  margin-bottom: 11rem;
}
.c__container {
  min-height: 50px;
  height: fit-content;
  transition: 1.3s ease all;
  border: 0px solid transparent;
  width: 100%;
}
.c__container-active {
  border: 1px solid var(--grey-0);
  height: 80vh;
}
.empty-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.c__item {
  width: 100%;
  display: flex;
  margin-top: -1px;
}

.empty-message {
  color: white;
  font-style: italic;
  padding: 20px;
  text-align: center;
  width: 100%;
}
</style>
